import { render, staticRenderFns } from "./code_identification.vue?vue&type=template&id=34257606&scoped=true&"
import script from "./code_identification.vue?vue&type=script&lang=js&"
export * from "./code_identification.vue?vue&type=script&lang=js&"
import style0 from "./code_identification.vue?vue&type=style&index=0&id=34257606&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34257606",
  null
  
)

export default component.exports